const cropApplicationDrafts = [
    {
        "applicant": "楊小花",
        "operator": "楊小花",
        "identityType": "individual",
        "appNo": "202100012",
        "appType": "initial",
        "createdOn": "2021-03-12T08:20:10.000Z",
        "legalStatus": "naturalPerson",
        "personInCharge": "楊小花",
        "farmName": "開心農場",
        "farmHasBeenRegistered": true,
        "registrationDate": "2018-03-12T08:20:10.000Z",
        "registrationNo": "09123098",
        "agricultureProductOperator": "楊小花",
        "IdNumber": "A123456789",
        "gender": "male",
        "phone": "02-77238001",
        "mobilePhone": "0912345009",
        "fax": "02-77238002",
        "email": "flower@gmail.com",
        "lineAccount": "Flower011",
        "permanentAddress": {
            "country": "TW",
            "zip": "11501",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號5樓"
        },
        "contactPerson": {
            "name": "楊小花",
            "phone": "02-77238001",
            "cellPhone": "0912345009",
            "email": "flower@gmail.com",
            "lineAccount": "Flower011",
        },
        "bankName": "822",
        "bankBranch": "0185",
        "beneficiaryName": "楊小花",
        "beneficiaryAccount": "1234009129001",
        "agricultureAgencyBranch": "123",
        "certificationFields": [
            {
                "id": '1',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "1192-0000地號",
                "area": "0.251",
                "productRanges": ["甘藍(高麗菜)", "包心白菜", "結球萵苣", "青江菜", "芥藍", "韭菜", "莧菜", "筊白筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": false
            },
            {
                "id": '2',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "1208-0000地號",
                "area": "0.251",
                "productRanges": ["甘藍(高麗菜)","包心白菜","結球萵苣", "青江菜","芥藍","韭菜","莧菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": false
            },
            {
                "id": '3',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0308-0000地號",
                "area": "0.0036",
                "productRanges": ["蘿蔔","胡蘿蔔","薑","洋蔥","馬鈴薯","竹筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true,
            },
            {
                "id": '4',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0309-0000地號",
                "area": "0.0807",
                "productRanges": ["蘿蔔","胡蘿蔔","薑","洋蔥","馬鈴薯","竹筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true
            },
            {
                "id": '5',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0310-0000地號",
                "area": "0.0444",
                "productRanges": ["苦瓜","絲瓜", "豌豆","毛豆"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true
            }
        ],
        "whetherToApplySelfProduced": "yes",
        "selfProducedProcesses": [
              {
                  "plant": "林記碾米廠",
                  "registrationNo": "A09111090",
                  "personInCharge": "林阿滿",
                  "phone": "02-7723-8001",
                  "address": {
                      "country": "TW",
                      "zip": "268021",
                      "city": "yilan",
                      "district": "五結鄉",
                      "street": "孝威路402號"
                  },
                  "property": "nonOwned",
                  "certificationBody": "采園生態驗證有限公司",
                  "organicCertificateNo": "1-008-100200",
                  "certificateProductItem": "稻穀之碾製品"
              },
              {
                  "plant": "林記碾米廠",
                  "registrationNo": "A09111090",
                  "personInCharge": "林阿滿",
                  "phone": "02-7723-8001",
                  "address": {
                      "country": "TW",
                      "zip": "268021",
                      "city": "yilan",
                      "district": "五結鄉",
                      "street": "孝威路402號"
                  },
                  "property": "owned",
                  "oem": "doOem",
                  "oemInfos": [
                      {
                          "oemProduct": "稻穀之碾製品",
                          "cropVerificationLevel": "conventional",
                          "processingContent": ["烘乾","碾製"],
                          "equipment": "烘米機、碾米機",
                          "avoidToContamination": "吸塵器"
                      },
                      {
                          "oemProduct": "稻穀之脫殼",
                          "cropVerificationLevel": "conventional",
                          "processingContent": ["碎米","碾製"],
                          "equipment": "碎米機",
                          "avoidToContamination": "吸塵器"
                      }
                  ]
              }
        ],
        "nonCertificateField": "yes",
        "nonCertificateFields":[
            {
                "id": "1",
                "operationMethod":"conventional",
                "area":0.3438,
                "productRanges": ["甘藍(高麗菜)","包心白菜","結球萵苣", "青江菜","芥藍","韭菜","莧菜"]
            }
        ],
        "reproductiveMaterialSurveys": [
            {
                "name": ["甘藍(高麗菜)","包心白菜"],
                "originProof": "outsourcingOrGift",
                "certifiedDocumentType": "organic"
            },
            {
                "name": ["毛豆"],
                "originProof": "nonPurchased",
                "nonPurchasedDescription": "selfRetained"
            }
        ],
        "whetherOffGroundCultivation": "yes",
        "offGroundCultivations": [
            {
                "name": "豌豆",
                "scope": "partial",
                "reason": "離地栽培( Off-ground Cultivation )法，除了保護土壤及避免土壤受到重金屬危害外，搭配現今發展的立體栽培法或層架法，更可增加栽種產量，目前溫室發展技術完善的牛番茄或菇類等都屬此栽培法",
                "mediumMaterial": "無土養液"
            }
        ],
        "whetherFertilizerMaterial": "yes",
        "fertilizerMaterials": [
            {
                "registrationType": "registered",
                "product": "福壽牌生機栽培專用肥426",
                "registeredNo": "肥製(質)字第0085078號",
                "itemName": "5-13-雜項有機質肥料",
                "organicRegisteredNo": "100001",
                "source": "福壽實業股份有限公司",
                "ingredient": ["蓖蔴粕","菜籽粕","椰子粕","芝麻粕","草木灰"],
                "methodAndDosage": "整地開植溝時，條施或撒施並均勻拌入土中。用量180公斤"
            },
            {
                "registrationType": "registered",
                "product": "東農牌1號有機質肥料",
                "registeredNo": "肥製(質)字第0042029號",
                "itemName": "植物渣粕肥料(5-01)",
                "source": "保證責任嘉義縣東石合作農場",
                "organicRegisteredNo": "100006",
                "ingredient": ["花生粕","米糠","芝麻粕","椰子粕","蓖麻粕","黃豆粕"],
                "methodAndDosage": "第一次碎土整地前，採全面撒施並均勻拌入土中。用量60公斤"
            },
            {
                "registrationType": "registered",
                "product": "青春牌超級肥",
                "registeredNo": "肥製(質)字第0004005號",
                "itemName": "混合有機質肥料(5-12)",
                "source": "力漢企業股份有限公司",
                "organicRegisteredNo": "101005",
                "ingredient": ["豆粉","菜籽粕","肉骨粉","魚粉","苜蓿"],
                "methodAndDosage": "全面撒施並均勻拌入土中。用量200公斤"
            },
            {
                "registrationType": "noRegistration",
                "product": "牛糞堆肥",
                "registeredNo": "無登記",
                "source": "朋友提供",
                "ingredient": "牛糞",
                "methodAndDosage": "用量300公斤"
            },
        ],
        "whetherPreventionMaterial": "yes",
        "preventionMaterials": [
            {
                "registrationType": "pesticide",
                "registeredNo": "農藥製字第05323號",
                "organicRegisteredNo": "101007",
                "product": "台灣水寶",
                "source": "百泰生物科技股份有限公司",
                "ingredient": "枯草桿菌"
            },
            {
                "registrationType": "pesticide",
                "registeredNo": "農藥製字第05277號",
                "organicRegisteredNo": "107042",
                "product": "興農寶",
                "source": "興農股份有限公司",
                "ingredient": "枯草桿菌"
            },
            {
                "registrationType": "planProtection",
                "registeredNo": "植保製字第00071號",
                "organicRegisteredNo": "107037",
                "product": "油夠好用",
                "source": "興農股份有限公司",
                "ingredient": "苦楝油"
            },
            {
                "product": "亞磷酸",
                "registrationType": "noRegistration",
                "source": "振勇",
            },
        ],
        "agricultureProductMaps": [
            {
                "id": "1",
                "farmer": "楊小花",
                "name": "石郎",
                "landLotSerialNo": [
                    "雙龍段0308-0000地號",
                ],
                "disabled": false,
                "uploadDate": "2021-03-12T08:20:10.000Z"
            }
        ]
    },
    {
        "applicant": "宜蘭縣五結鄉稻米產銷班第一班",
        "operator": "楊小花",
        "appNo": "202100032",
        "appType": "expanding",
        "createdOn": "2021-04-12T08:20:10.000Z",
        "legalStatus": "makingTeam",
        "personInCharge": "陳富貴",
        "agricultureProductOperator": "陳富貴",
        "birthday": "1980-04-12T08:20:10.000Z",
        "IdNumber": "A102217362",
        "identityType": "group",
        "gender": "male",
        "phone": "02-77238001",
        "mobilePhone": "0912345009",
        "fax": "02-77238002",
        "email": "flower@gmail.com",
        "lineAccount": "Flower011",
        "permanentAddress": {
            "country": "TW",
            "zip": "11501",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號5樓"
        },
        "bankName": "822",
        "bankBranch": "0185",
        "beneficiaryName": "楊小花",
        "beneficiaryAccount": "1234009129001",
        "agricultureAgencyBranch": "123",
        "certificationFields": [
            {
                "id": '1',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "1192-0000",
                "area": "0.251",
                "productRanges": ["甘藍(高麗菜)", "包心白菜", "結球萵苣", "青江菜", "芥藍", "韭菜", "莧菜", "筊白筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": false
            },
            {
                "id": '2',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "1208-0000",
                "area": "0.251",
                "productRanges": ["甘藍(高麗菜)","包心白菜","結球萵苣", "青江菜","芥藍","韭菜","莧菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": false
            },
            {
                "id": '3',
                "farmer": "楊小胖",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0308-0000",
                "area": "0.0036",
                "productRanges": ["蘿蔔","胡蘿蔔","薑","洋蔥","馬鈴薯","竹筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true
            },
            {
                "id": '4',
                "farmer": "楊小胖",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0309-0000",
                "area": "0.0807",
                "productRanges": ["蘿蔔","胡蘿蔔","薑","洋蔥","馬鈴薯","竹筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true
            },
            {
                "id": '5',
                "farmer": "楊小胖",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0310-0000",
                "area": "0.0444",
                "productRanges": ["苦瓜","絲瓜", "豌豆","毛豆"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true
            }
        ],
        "groupMembers": [
            {
                "farmer": "楊小花",
                "idNo": "A123456789",
                "memberNumber": "12"
            },
            {
                "farmer": "楊小胖",
                "idNo": "C123456789",
                "memberNumber": "8"
            },
        ],
        "agricultureProductMaps": [
            {
                "id": "1",
                "farmer": "楊小花",
                "name": "石郎",
                "landLotSerialNo": [
                    "雙龍段0308-0000地號",
                ],
                "disabled": false,
                "uploadDate": "2021-03-12T08:20:10.000Z"
            },
            {
                "id": "2",
                "farmer": "楊小胖",
                "name": "石胖",
                "landLotSerialNo": [
                    "雙龍段0308-0000地號",
                ],
                "disabled": false,
                "uploadDate": "2021-03-12T08:20:10.000Z"
            },
        ]
    },
    {
        "applicant": "楊小花",
        "operator": "楊小花",
        "identityType": "individual",
        "appNo": "202100092",
        "appType": "expanding",
        "createdOn": "2021-05-12T08:20:10.000Z",
        "legalStatus": "naturalPerson",
        "personInCharge": "楊小花"
    },
    {
        "applicant": "楊小花",
        "operator": "楊小花",
        "identityType": "individual",
        "appNo": "202100015",
        "appType": "followUp1",
        "createdOn": "2021-03-12T08:20:10.000Z",
        "legalStatus": "naturalPerson",
        "personInCharge": "楊小花",
        "farmName": "開心農場",
        "farmHasBeenRegistered": true,
        "registrationDateDeadline": "2023-12-20T00:00:00.000Z",
        "registrationDoc": {
            "type": "",
            "size": 0,
            "bytes": "",
            "name": "設立文件.pdf",
            "lastModified": 0
        },
        "registrationDate": "2018-03-12T08:20:10.000Z",
        "registrationNo": "09123098",
        "agricultureProductOperator": "楊小花",
        "IdNumber": "A123456789",
        "gender": "male",
        "phone": "02-77238001",
        "cellPhone": "0912345009",
        "fax": "02-77238002",
        "email": "flower@gmail.com",
        "website": "http://www.tw-toc.com/",
        "legalAuthority": "楊小花",
        "relationship": "本人",
        "lineAccount": "Flower011",
        "permanentAddress": {
            "country": "TW",
            "zip": "11501",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號5樓"
        },
        "mailingAddress": {
            "country": "TW",
            "zip": "11501",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號5樓"
        },
        "deliverAddress": {
            "country": "TW",
            "zip": "11501",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號5樓"
        },
        "contactPerson": {
            "name": "楊小花",
            "phone": "02-77238001",
            "cellPhone": "0912345009",
            "email": "flower@gmail.com",
            "lineAccount": "Flower011",
        },
        "certificateHistory": {
            "applyOtherCertificateBody": "yes",
            "switchToMyCompanyReason": "慈心有機驗證品質好、口碑好，值得信賴。",
            "otherCertificateQualification": "no",
            "beenNotifiedPastThreeYear": ["temporaryTermination", "reject"],
            "cooperateGovernmentPlan": "no",
        },
        "bankName": "822",
        "bankBranch": "0185",
        "beneficiaryName": "楊小花",
        "beneficiaryAccount": "1234009129001",
        "agricultureAgencyBranch": "123",
        "passbookCoverCopy": {
            "type": "image/jpeg",
            "size": 0,
            "bytes": "",
            "name": "存摺封面影本.jpg",
            "lastModified": 0
        },
        "idCardFrontCopy": {
            "type": "image/jpeg",
            "size": 0,
            "bytes": "",
            "name": "身分證正面影本.jpg",
            "lastModified": 0
        },
        "idCardReverseCopy": {
            "type": "image/jpeg",
            "size": 0,
            "bytes": "",
            "name": "身分證反面影本.jpg",
            "lastModified": 0
        },
        "certificationFields": [
            {
                "id": '1',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "1192-0000地號",
                "area": "0.251",
                "productRanges": ["甘藍(高麗菜)", "包心白菜", "結球萵苣", "青江菜", "芥藍", "韭菜", "莧菜", "筊白筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": false
            },
            {
                "id": '2',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "1208-0000地號",
                "area": "0.251",
                "productRanges": ["甘藍(高麗菜)","包心白菜","結球萵苣", "青江菜","芥藍","韭菜","莧菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": false
            },
            {
                "id": '3',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0308-0000地號",
                "area": "0.0036",
                "productRanges": ["蘿蔔","胡蘿蔔","薑","洋蔥","馬鈴薯","竹筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true,
                "shortenTransitionPeriodConfirmation": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "申請縮短轉型期文件.pdf",
                    "lastModified": 0
                }
            },
            {
                "id": '4',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0309-0000地號",
                "area": "0.0807",
                "productRanges": ["蘿蔔","胡蘿蔔","薑","洋蔥","馬鈴薯","竹筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true,
                "shortenTransitionPeriodConfirmation": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "申請縮短轉型期文件.pdf",
                    "lastModified": 0
                }
            },
            {
                "id": '5',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0310-0000地號",
                "area": "0.0444",
                "productRanges": ["苦瓜","絲瓜", "豌豆","毛豆"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true,
                "shortenTransitionPeriodConfirmation": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "申請縮短轉型期文件.pdf",
                    "lastModified": 0
                }
            }
        ],
        "property": {
            "landProperty": [
                {
                    "id": "1",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "1192-0000地號",
                    "area": "0.251",
                    "landProperty": "privateOwnedAll",
                    "registrationHectare": 20,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                },
                {
                    "id": "2",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "1208-0000地號",
                    "area": "0.251",
                    "landProperty": "privateOwnedAll",
                    "registrationHectare": 30,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                },
                {
                    "id": "3",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "0308-0000地號",
                    "area": "0.0036",
                    "landProperty": "taiSugarLand",
                    "registrationHectare": 40,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                },
                {
                    "id": "4",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "0309-0000地號",
                    "area": "0.0807",
                    "landProperty": "nationalLand",
                    "registrationHectare": 50,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                },
                {
                    "id": "5",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "0310-0000地號",
                    "area": "0.444",
                    "landProperty": "privateNotOwned",
                    "registrationHectare": 60,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                }
            ],
            "leaseManagement": [
                {
                    "landLotSerialNo": ["田洋段1192-0000地號", "雙龍段0310-0000地號"],
                    "leaseType": "lease",
                    "leaseExpiryDate": "2024-06-15T00:00:00.000Z",
                    "leaseFile": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "租用檔案.pdf",
                        "lastModified": 0
                    }
                }
            ]
        },
        "whetherToApplySelfProduced": "yes",
        "selfProducedProcesses": [
            {
                "plant": "林記碾米廠",
                "registrationNo": "A09111090",
                "personInCharge": "林阿滿",
                "phone": "02-7723-8001",
                "address": {
                    "country": "TW",
                    "zip": "268021",
                    "city": "yilan",
                    "district": "五結鄉",
                    "street": "孝威路402號"
                },
                "property": "nonOwned",
                "certificationBody": "采園生態驗證有限公司",
                "organicCertificateNo": "1-008-100200",
                "certificateProductItem": "稻穀之碾製品"
            },
            {
                "plant": "林記碾米廠",
                "registrationNo": "A09111090",
                "personInCharge": "林阿滿",
                "phone": "02-7723-8001",
                "address": {
                    "country": "TW",
                    "zip": "268021",
                    "city": "yilan",
                    "district": "五結鄉",
                    "street": "孝威路402號"
                },
                "property": "owned",
                "oem": "doOem",
                "oemInfos": [
                    {
                        "oemProduct": "稻穀之碾製品",
                        "cropVerificationLevel": "conventional",
                        "processingContent": ["烘乾","碾製"],
                        "equipment": "烘米機、碾米機",
                        "avoidToContamination": "吸塵器"
                    },
                    {
                        "oemProduct": "稻穀之脫殼",
                        "cropVerificationLevel": "conventional",
                        "processingContent": ["碎米","碾製"],
                        "equipment": "碎米機",
                        "avoidToContamination": "吸塵器"
                    }
                ]
            }
        ],
        "productFlowCharts": [
            {
                "fileDescription": {
                    "name": "生產流程圖"
                },
                "description": "礦泉水生產流程圖"
            }
        ],
        "processedProducts": [
            {
                "productName": "礦泉水",
                "material": "水",
                "productionFlowChart": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "生產流程圖.pdf",
                        "lastModified": 0
                    }
                ],
                "processingSite": ["林記碾米廠"]
            }
        ],
        "nonCertificateField":true,
        "nonCertificateFields":[
            {
                "id": "1",
                "operationMethod":"conventional",
                "area":0.3438,
                "productRanges": ["甘藍(高麗菜)","包心白菜","結球萵苣", "青江菜","芥藍","韭菜","莧菜"]
            }
        ],
        "reproductiveMaterialSurveys": [
            {
                "name": ["甘藍(高麗菜)","包心白菜"],
                "originProof": "outsourcingOrGift",
                "certifiedDocumentType": "organic"
            },
            {
                "name": ["毛豆"],
                "originProof": "nonPurchased",
                "nonPurchasedDescription": "selfRetained"
            }
        ],
        "whetherOffGroundCultivation": "yes",
        "offGroundCultivations": [
            {
                "name": "豌豆",
                "scope": "partial",
                "reason": "離地栽培( Off-ground Cultivation )法，除了保護土壤及避免土壤受到重金屬危害外，搭配現今發展的立體栽培法或層架法，更可增加栽種產量，目前溫室發展技術完善的牛番茄或菇類等都屬此栽培法",
                "mediumMaterial": "無土養液"
            }
        ],
        "whetherFertilizerMaterial": "yes",
        "fertilizerMaterials": [
            {
                "registrationType": "registered",
                "product": "福壽牌生機栽培專用肥426",
                "registeredNo": "肥製(質)字第0085078號",
                "itemName": "5-13-雜項有機質肥料",
                "organicRegisteredNo": "100001",
                "source": "福壽實業股份有限公司",
                "ingredient": ["蓖蔴粕","菜籽粕","椰子粕","芝麻粕","草木灰"],
                "methodAndDosage": "整地開植溝時，條施或撒施並均勻拌入土中。用量180公斤",
                "attachment": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "有機證明書.pdf",
                        "lastModified": 0
                    },
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "有機農業商品化資材表.pdf",
                        "lastModified": 0
                    },
                ]
            },
            {
                "registrationType": "registered",
                "product": "東農牌1號有機質肥料",
                "registeredNo": "肥製(質)字第0042029號",
                "itemName": "植物渣粕肥料(5-01)",
                "source": "保證責任嘉義縣東石合作農場",
                "organicRegisteredNo": "100006",
                "ingredient": ["花生粕","米糠","芝麻粕","椰子粕","蓖麻粕","黃豆粕"],
                "methodAndDosage": "第一次碎土整地前，採全面撒施並均勻拌入土中。用量60公斤",
                "attachment": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "有機農業商品化資材表.pdf",
                        "lastModified": 0
                    }
                ]
            },
            {
                "registrationType": "registered",
                "product": "青春牌超級肥",
                "registeredNo": "肥製(質)字第0004005號",
                "itemName": "混合有機質肥料(5-12)",
                "source": "力漢企業股份有限公司",
                "organicRegisteredNo": "101005",
                "ingredient": ["豆粉","菜籽粕","肉骨粉","魚粉","苜蓿"],
                "methodAndDosage": "全面撒施並均勻拌入土中。用量200公斤",
                "attachment": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "有機農業商品化資材表.pdf",
                        "lastModified": 0
                    }
                ]
            },
            {
                "registrationType": "noRegistration",
                "product": "牛糞堆肥",
                "registeredNo": "無登記",
                "source": "朋友提供",
                "ingredient": "牛糞",
                "methodAndDosage": "用量300公斤"
            },
        ],
        "whetherPreventionMaterial": "yes",
        "preventionMaterials": [
            {
                "registrationType": "pesticide",
                "registeredNo": "農藥製字第05323號",
                "organicRegisteredNo": "101007",
                "product": "台灣水寶",
                "source": "百泰生物科技股份有限公司",
                "ingredient": "枯草桿菌",
                "methodAndDosage": "噴霧法。每公頃每次施用1公斤，藥液量100公升",
                "controlTarget": "夜蛾類, 稻苞蟲, 負泥蟲",
                "attachment": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "植物病蟲草害防治資材一覽表.pdf",
                        "lastModified": 0
                    },
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "許可證明.jpg",
                        "lastModified": 0
                    }
                ]
            },
            {
                "registrationType": "pesticide",
                "registeredNo": "農藥製字第05277號",
                "organicRegisteredNo": "107042",
                "product": "興農寶",
                "source": "興農股份有限公司",
                "ingredient": "枯草桿菌",
                "methodAndDosage": "種子處理法。每公頃每次施用1.2公斤，藥液量150公升",
                "controlTarget": "青椿象, 南方綠椿象",
                "attachment": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "植物病蟲草害防治資材一覽表.pdf",
                        "lastModified": 0
                    },
                ]
            },
            {
                "registrationType": "planProtection",
                "registeredNo": "植保製字第00071號",
                "organicRegisteredNo": "107037",
                "product": "油夠好用",
                "source": "興農股份有限公司",
                "ingredient": "苦楝油",
                "methodAndDosage": "灌注法。每公頃每次施用2公斤，藥液量200公升",
                "controlTarget": "粉介殼蟲類, 細蛾類, 膠蟲",
                "attachment": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "植物病蟲草害防治資材一覽表.pdf",
                        "lastModified": 0
                    },
                ]
            },
            {
                "product": "亞磷酸",
                "registrationType": "noRegistration",
                "source": "振勇",
                "methodAndDosage": "噴霧法。每公頃每次施用1公斤，藥液量100公升",
                "controlTarget": "一點螟蟲, 二化螟蟲"
            },
        ],
        "relatedAttachments": {
            "workRecord":[
                {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "2022年度工作記錄.pdf",
                    "lastModified": 0
                }
            ],
            "fertilityAnalysis": [
                {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "土壤肥力分析.pdf",
                    "lastModified": 0
                }
            ],
            "fertilityAnalysisDesc": "肥力良好",
            "waterBillSlip": {
                "type": "",
                "size": 0,
                "bytes": "",
                "name": "自來水費繳費單.pdf",
                "lastModified": 0
            },
            "heathReport": {
                "type": "",
                "size": 0,
                "bytes": "",
                "name": "健康檢查報告.pdf",
                "lastModified": 0
            },
            "others": [
                {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "天然氣繳費單.pdf",
                    "lastModified": 0
                },
                {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "肥力監控器具清單.pdf",
                    "lastModified": 0
                }
            ]
        },
        "agricultureProductMaps": [
            {
                "id": "1",
                "farmer": "楊小花",
                "name": "石郎",
                "landLotSerialNo": [
                    "雙龍段0308-0000地號",
                ],
                "disabled": false,
                "uploadDate": "2021-03-12T08:20:10.000Z"
            }
        ]
    },
    {
        "applicant": "楊小花",
        "operator": "楊小花",
        "identityType": "individual",
        "appNo": "202100016",
        "appType": "renewal",
        "createdOn": "2021-03-12T08:20:10.000Z",
        "legalStatus": "naturalPerson",
        "personInCharge": "楊小花",
        "farmName": "開心農場",
        "farmHasBeenRegistered": true,
        "registrationDateDeadline": "2023-12-20T00:00:00.000Z",
        "registrationDoc": {
            "type": "",
            "size": 0,
            "bytes": "",
            "name": "設立文件.pdf",
            "lastModified": 0
        },
        "registrationDate": "2018-03-12T08:20:10.000Z",
        "registrationNo": "09123098",
        "agricultureProductOperator": "楊小花",
        "IdNumber": "A123456789",
        "gender": "male",
        "phone": "02-77238001",
        "cellPhone": "0912345009",
        "fax": "02-77238002",
        "email": "flower@gmail.com",
        "website": "http://www.tw-toc.com/",
        "legalAuthority": "楊小花",
        "relationship": "本人",
        "lineAccount": "Flower011",
        "permanentAddress": {
            "country": "TW",
            "zip": "11501",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號5樓"
        },
        "mailingAddress": {
            "country": "TW",
            "zip": "11501",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號5樓"
        },
        "deliverAddress": {
            "country": "TW",
            "zip": "11501",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號5樓"
        },
        "contactPerson": {
            "name": "楊小花",
            "phone": "02-77238001",
            "cellPhone": "0912345009",
            "email": "flower@gmail.com",
            "lineAccount": "Flower011",
        },
        "certificateHistory": {
            "applyOtherCertificateBody": "yes",
            "switchToMyCompanyReason": "慈心有機驗證品質好、口碑好，值得信賴。",
            "otherCertificateQualification": "no",
            "beenNotifiedPastThreeYear": ["temporaryTermination", "reject"],
            "cooperateGovernmentPlan": "no",
        },
        "bankName": "822",
        "bankBranch": "0185",
        "beneficiaryName": "楊小花",
        "beneficiaryAccount": "1234009129001",
        "agricultureAgencyBranch": "123",
        "passbookCoverCopy": {
            "type": "image/jpeg",
            "size": 0,
            "bytes": "",
            "name": "存摺封面影本.jpg",
            "lastModified": 0
        },
        "idCardFrontCopy": {
            "type": "image/jpeg",
            "size": 0,
            "bytes": "",
            "name": "身分證正面影本.jpg",
            "lastModified": 0
        },
        "idCardReverseCopy": {
            "type": "image/jpeg",
            "size": 0,
            "bytes": "",
            "name": "身分證反面影本.jpg",
            "lastModified": 0
        },
        "certificationFields": [
            {
                "id": '1',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "1192-0000地號",
                "area": "0.251",
                "productRanges": ["甘藍(高麗菜)", "包心白菜", "結球萵苣", "青江菜", "芥藍", "韭菜", "莧菜", "筊白筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": false
            },
            {
                "id": '2',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "1208-0000地號",
                "area": "0.251",
                "productRanges": ["甘藍(高麗菜)","包心白菜","結球萵苣", "青江菜","芥藍","韭菜","莧菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": false
            },
            {
                "id": '3',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0308-0000地號",
                "area": "0.0036",
                "productRanges": ["蘿蔔","胡蘿蔔","薑","洋蔥","馬鈴薯","竹筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true,
                "shortenTransitionPeriodConfirmation": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "申請縮短轉型期文件.pdf",
                    "lastModified": 0
                }
            },
            {
                "id": '4',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0309-0000地號",
                "area": "0.0807",
                "productRanges": ["蘿蔔","胡蘿蔔","薑","洋蔥","馬鈴薯","竹筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true,
                "shortenTransitionPeriodConfirmation": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "申請縮短轉型期文件.pdf",
                    "lastModified": 0
                }
            },
            {
                "id": '5',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0310-0000地號",
                "area": "0.0444",
                "productRanges": ["苦瓜","絲瓜", "豌豆","毛豆"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true,
                "shortenTransitionPeriodConfirmation": {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "申請縮短轉型期文件.pdf",
                    "lastModified": 0
                }
            }
        ],
        "property": {
            "landProperty": [
                {
                    "id": "1",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "1192-0000地號",
                    "area": "0.251",
                    "landProperty": "privateOwnedAll",
                    "registrationHectare": 20,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                },
                {
                    "id": "2",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "1208-0000地號",
                    "area": "0.251",
                    "landProperty": "privateOwnedAll",
                    "registrationHectare": 30,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                },
                {
                    "id": "3",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "0308-0000地號",
                    "area": "0.0036",
                    "landProperty": "taiSugarLand",
                    "registrationHectare": 40,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                },
                {
                    "id": "4",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "0309-0000地號",
                    "area": "0.0807",
                    "landProperty": "nationalLand",
                    "registrationHectare": 50,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                },
                {
                    "id": "5",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "0310-0000地號",
                    "area": "0.444",
                    "landProperty": "privateNotOwned",
                    "registrationHectare": 60,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                }
            ],
            "leaseManagement": [
                {
                    "landLotSerialNo": ["田洋段1192-0000地號", "雙龍段0310-0000地號"],
                    "leaseType": "lease",
                    "leaseExpiryDate": "2024-06-15T00:00:00.000Z",
                    "leaseFile": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "租用檔案.pdf",
                        "lastModified": 0
                    }
                }
            ]
        },
        "whetherToApplySelfProduced": "yes",
        "selfProducedProcesses": [
            {
                "plant": "林記碾米廠",
                "registrationNo": "A09111090",
                "personInCharge": "林阿滿",
                "phone": "02-7723-8001",
                "address": {
                    "country": "TW",
                    "zip": "268021",
                    "city": "yilan",
                    "district": "五結鄉",
                    "street": "孝威路402號"
                },
                "property": "nonOwned",
                "certificationBody": "采園生態驗證有限公司",
                "organicCertificateNo": "1-008-100200",
                "certificateProductItem": "稻穀之碾製品"
            },
            {
                "plant": "林記碾米廠",
                "registrationNo": "A09111090",
                "personInCharge": "林阿滿",
                "phone": "02-7723-8001",
                "address": {
                    "country": "TW",
                    "zip": "268021",
                    "city": "yilan",
                    "district": "五結鄉",
                    "street": "孝威路402號"
                },
                "property": "owned",
                "oem": "doOem",
                "oemInfos": [
                    {
                        "oemProduct": "稻穀之碾製品",
                        "cropVerificationLevel": "conventional",
                        "processingContent": ["烘乾","碾製"],
                        "equipment": "烘米機、碾米機",
                        "avoidToContamination": "吸塵器"
                    },
                    {
                        "oemProduct": "稻穀之脫殼",
                        "cropVerificationLevel": "conventional",
                        "processingContent": ["碎米","碾製"],
                        "equipment": "碎米機",
                        "avoidToContamination": "吸塵器"
                    }
                ]
            }
        ],
        "productFlowCharts": [
            {
                "fileDescription": {
                    "name": "生產流程圖"
                },
                "description": "礦泉水生產流程圖"
            }
        ],
        "processedProducts": [
            {
                "productName": "礦泉水",
                "material": "水",
                "productionFlowChart": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "生產流程圖.pdf",
                        "lastModified": 0
                    }
                ],
                "processingSite": ["林記碾米廠"]
            }
        ],
        "nonCertificateField":true,
        "nonCertificateFields":[
            {
                "id": "1",
                "operationMethod":"conventional",
                "area":0.3438,
                "productRanges": ["甘藍(高麗菜)","包心白菜","結球萵苣", "青江菜","芥藍","韭菜","莧菜"]
            }
        ],
        "reproductiveMaterialSurveys": [
            {
                "name": ["甘藍(高麗菜)","包心白菜"],
                "originProof": "outsourcingOrGift",
                "certifiedDocumentType": "organic"
            },
            {
                "name": ["毛豆"],
                "originProof": "nonPurchased",
                "nonPurchasedDescription": "selfRetained"
            }
        ],
        "whetherOffGroundCultivation": "yes",
        "offGroundCultivations": [
            {
                "name": "豌豆",
                "scope": "partial",
                "reason": "離地栽培( Off-ground Cultivation )法，除了保護土壤及避免土壤受到重金屬危害外，搭配現今發展的立體栽培法或層架法，更可增加栽種產量，目前溫室發展技術完善的牛番茄或菇類等都屬此栽培法",
                "mediumMaterial": "無土養液"
            }
        ],
        "whetherFertilizerMaterial": "yes",
        "fertilizerMaterials": [
            {
                "registrationType": "registered",
                "product": "福壽牌生機栽培專用肥426",
                "registeredNo": "肥製(質)字第0085078號",
                "itemName": "5-13-雜項有機質肥料",
                "organicRegisteredNo": "100001",
                "source": "福壽實業股份有限公司",
                "ingredient": ["蓖蔴粕","菜籽粕","椰子粕","芝麻粕","草木灰"],
                "methodAndDosage": "整地開植溝時，條施或撒施並均勻拌入土中。用量180公斤",
                "attachment": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "有機證明書.pdf",
                        "lastModified": 0
                    },
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "有機農業商品化資材表.pdf",
                        "lastModified": 0
                    },
                ]
            },
            {
                "registrationType": "registered",
                "product": "東農牌1號有機質肥料",
                "registeredNo": "肥製(質)字第0042029號",
                "itemName": "植物渣粕肥料(5-01)",
                "source": "保證責任嘉義縣東石合作農場",
                "organicRegisteredNo": "100006",
                "ingredient": ["花生粕","米糠","芝麻粕","椰子粕","蓖麻粕","黃豆粕"],
                "methodAndDosage": "第一次碎土整地前，採全面撒施並均勻拌入土中。用量60公斤",
                "attachment": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "有機農業商品化資材表.pdf",
                        "lastModified": 0
                    }
                ]
            },
            {
                "registrationType": "registered",
                "product": "青春牌超級肥",
                "registeredNo": "肥製(質)字第0004005號",
                "itemName": "混合有機質肥料(5-12)",
                "source": "力漢企業股份有限公司",
                "organicRegisteredNo": "101005",
                "ingredient": ["豆粉","菜籽粕","肉骨粉","魚粉","苜蓿"],
                "methodAndDosage": "全面撒施並均勻拌入土中。用量200公斤",
                "attachment": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "有機農業商品化資材表.pdf",
                        "lastModified": 0
                    }
                ]
            },
            {
                "registrationType": "noRegistration",
                "product": "牛糞堆肥",
                "registeredNo": "無登記",
                "source": "朋友提供",
                "ingredient": "牛糞",
                "methodAndDosage": "用量300公斤"
            },
        ],
        "whetherPreventionMaterial": "yes",
        "preventionMaterials": [
            {
                "registrationType": "pesticide",
                "registeredNo": "農藥製字第05323號",
                "organicRegisteredNo": "101007",
                "product": "台灣水寶",
                "source": "百泰生物科技股份有限公司",
                "ingredient": "枯草桿菌",
                "methodAndDosage": "噴霧法。每公頃每次施用1公斤，藥液量100公升",
                "controlTarget": "夜蛾類, 稻苞蟲, 負泥蟲",
                "attachment": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "植物病蟲草害防治資材一覽表.pdf",
                        "lastModified": 0
                    },
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "許可證明.jpg",
                        "lastModified": 0
                    }
                ]
            },
            {
                "registrationType": "pesticide",
                "registeredNo": "農藥製字第05277號",
                "organicRegisteredNo": "107042",
                "product": "興農寶",
                "source": "興農股份有限公司",
                "ingredient": "枯草桿菌",
                "methodAndDosage": "種子處理法。每公頃每次施用1.2公斤，藥液量150公升",
                "controlTarget": "青椿象, 南方綠椿象",
                "attachment": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "植物病蟲草害防治資材一覽表.pdf",
                        "lastModified": 0
                    },
                ]
            },
            {
                "registrationType": "planProtection",
                "registeredNo": "植保製字第00071號",
                "organicRegisteredNo": "107037",
                "product": "油夠好用",
                "source": "興農股份有限公司",
                "ingredient": "苦楝油",
                "methodAndDosage": "灌注法。每公頃每次施用2公斤，藥液量200公升",
                "controlTarget": "粉介殼蟲類, 細蛾類, 膠蟲",
                "attachment": [
                    {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "植物病蟲草害防治資材一覽表.pdf",
                        "lastModified": 0
                    },
                ]
            },
            {
                "product": "亞磷酸",
                "registrationType": "noRegistration",
                "source": "振勇",
                "methodAndDosage": "噴霧法。每公頃每次施用1公斤，藥液量100公升",
                "controlTarget": "一點螟蟲, 二化螟蟲"
            },
        ],
        "relatedAttachments": {
            "workRecord":[
                {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "2022年度工作記錄.pdf",
                    "lastModified": 0
                }
            ],
            "fertilityAnalysis": [
                {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "土壤肥力分析.pdf",
                    "lastModified": 0
                }
            ],
            "fertilityAnalysisDesc": "肥力良好",
            "waterBillSlip": {
                "type": "",
                "size": 0,
                "bytes": "",
                "name": "自來水費繳費單.pdf",
                "lastModified": 0
            },
            "heathReport": {
                "type": "",
                "size": 0,
                "bytes": "",
                "name": "健康檢查報告.pdf",
                "lastModified": 0
            },
            "others": [
                {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "天然氣繳費單.pdf",
                    "lastModified": 0
                },
                {
                    "type": "",
                    "size": 0,
                    "bytes": "",
                    "name": "肥力監控器具清單.pdf",
                    "lastModified": 0
                }
            ]
        },
        "agricultureProductMaps": [
            {
                "id": "1",
                "farmer": "楊小花",
                "name": "石郎",
                "landLotSerialNo": [
                    "雙龍段0308-0000地號",
                ],
                "disabled": false,
                "uploadDate": "2021-03-12T08:20:10.000Z"
            }
        ],
        "UpdateHouseholdRegistration": [
            {
                "id": "1",
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "1192-0000地號",
                "area": "0.251",
                "landProperty": "privateOwnedAll",
                "registrationHectare": 20,
            },
            {
                "id": "2",
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "1208-0000地號",
                "area": "0.251",
                "landProperty": "privateOwnedAll",
                "registrationHectare": 30,
            },
            {
                "id": "3",
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "0308-0000地號",
                "area": "0.0036",
                "landProperty": "taiSugarLand",
                "registrationHectare": 40,
            },
            {
                "id": "4",
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "0309-0000地號",
                "area": "0.0807",
                "landProperty": "nationalLand",
                "registrationHectare": 50,
            },
            {
                "id": "5",
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "0310-0000地號",
                "area": "0.444",
                "landProperty": "privateNotOwned",
                "registrationHectare": 60,
            }
        ]
    },
    {
        "applicant": "楊小花",
        "operator": "楊小花",
        "identityType": "individual",
        "appNo": "202100072",
        "appType": "change",
        "createdOn": "2021-03-12T08:20:10.000Z",
        "legalStatus": "naturalPerson",
        "personInCharge": "楊小花",
        "farmName": "開心農場",
        "farmHasBeenRegistered": true,
        "registrationDate": "2018-03-12T08:20:10.000Z",
        "registrationNo": "09123098",
        "agricultureProductOperator": "楊小花",
        "IdNumber": "A123456789",
        "gender": "male",
        "phone": "02-77238001",
        "mobilePhone": "0912345009",
        "fax": "02-77238002",
        "email": "flower@gmail.com",
        "lineAccount": "Flower011",
        "permanentAddress": {
            "country": "TW",
            "zip": "11501",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號5樓"
        },
        "mailingAddress": {
            "country": "TW",
            "zip": "11501",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號5樓"
        },
        "contactPerson": {
            "name": "楊小花",
            "phone": "02-77238001",
            "cellPhone": "0912345009",
            "email": "flower@gmail.com",
            "lineAccount": "Flower011",
        },
        "bankName": "822",
        "bankBranch": "0185",
        "beneficiaryName": "楊小花",
        "beneficiaryAccount": "1234009129001",
        "agricultureAgencyBranch": "123",
        "passbookCoverCopy": {
            "type": "",
            "size": 0,
            "bytes": "0010",
            "name": "存摺封面影本.jpg",
            "lastModified": 0
        },
        "idCardFrontCopy": {
            "type": "",
            "size": 0,
            "bytes": "0010",
            "name": "身分證正面影本.jpg",
            "lastModified": 0
        },
        "idCardReverseCopy": {
            "type": "",
            "size": 0,
            "bytes": "0010",
            "name": "身分證反面影本.jpg",
            "lastModified": 0
        },
        "certificationFields": [
            {
                "id": '1',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "1192-0000地號",
                "area": "0.251",
                "productRanges": ["甘藍(高麗菜)", "包心白菜", "結球萵苣", "青江菜", "芥藍", "韭菜", "莧菜", "筊白筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": false
            },
            {
                "id": '2',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "田洋段",
                "landSerialNo": "1208-0000地號",
                "area": "0.251",
                "productRanges": ["甘藍(高麗菜)","包心白菜","結球萵苣", "青江菜","芥藍","韭菜","莧菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": false
            },
            {
                "id": '3',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0308-0000地號",
                "area": "0.0036",
                "productRanges": ["蘿蔔","胡蘿蔔","薑","洋蔥","馬鈴薯","竹筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true,
            },
            {
                "id": '4',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0309-0000地號",
                "area": "0.0807",
                "productRanges": ["蘿蔔","胡蘿蔔","薑","洋蔥","馬鈴薯","竹筍", "花椰菜"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true
            },
            {
                "id": '5',
                "farmer": "楊小花",
                "city": "yilan",
                "district": "五結鄉",
                "landLot": "雙龍段",
                "landSerialNo": "0310-0000地號",
                "area": "0.0444",
                "productRanges": ["苦瓜","絲瓜", "豌豆","毛豆"],
                "landOwnership": "owned",
                "shortenTransitionPeriod": true
            }
        ],
        "whetherToApplySelfProduced": "yes",
        "selfProducedProcesses": [
            {
                "plant": "林記碾米廠",
                "registrationNo": "A09111090",
                "personInCharge": "林阿滿",
                "phone": "02-7723-8001",
                "address": {
                    "country": "TW",
                    "zip": "268021",
                    "city": "yilan",
                    "district": "五結鄉",
                    "street": "孝威路402號"
                },
                "property": "nonOwned",
                "certificationBody": "采園生態驗證有限公司",
                "organicCertificateNo": "1-008-100200",
                "certificateProductItem": "稻穀之碾製品"
            },
            {
                "plant": "林記碾米廠",
                "registrationNo": "A09111090",
                "personInCharge": "林阿滿",
                "phone": "02-7723-8001",
                "address": {
                    "country": "TW",
                    "zip": "268021",
                    "city": "yilan",
                    "district": "五結鄉",
                    "street": "孝威路402號"
                },
                "property": "owned",
                "oem": "doOem",
                "oemInfos": [
                    {
                        "oemProduct": "稻穀之碾製品",
                        "cropVerificationLevel": "conventional",
                        "processingContent": ["烘乾","碾製"],
                        "equipment": "烘米機、碾米機",
                        "avoidToContamination": "吸塵器"
                    },
                    {
                        "oemProduct": "稻穀之脫殼",
                        "cropVerificationLevel": "conventional",
                        "processingContent": ["碎米","碾製"],
                        "equipment": "碎米機",
                        "avoidToContamination": "吸塵器"
                    }
                ]
            }
        ],
        "nonCertificateField": "yes",
        "nonCertificateFields":[
            {
                "id": "1",
                "operationMethod":"conventional",
                "area":0.3438,
                "productRanges": ["甘藍(高麗菜)","包心白菜","結球萵苣", "青江菜","芥藍","韭菜","莧菜"]
            }
        ],
        "reproductiveMaterialSurveys": [
            {
                "name": ["甘藍(高麗菜)","包心白菜"],
                "originProof": "outsourcingOrGift",
                "certifiedDocumentType": "organic"
            },
            {
                "name": ["毛豆"],
                "originProof": "nonPurchased",
                "nonPurchasedDescription": "selfRetained"
            }
        ],
        "whetherOffGroundCultivation": "yes",
        "offGroundCultivations": [
            {
                "name": "豌豆",
                "scope": "partial",
                "reason": "離地栽培( Off-ground Cultivation )法，除了保護土壤及避免土壤受到重金屬危害外，搭配現今發展的立體栽培法或層架法，更可增加栽種產量，目前溫室發展技術完善的牛番茄或菇類等都屬此栽培法",
                "mediumMaterial": "無土養液"
            }
        ],
        "whetherFertilizerMaterial": "yes",
        "fertilizerMaterials": [
            {
                "registrationType": "registered",
                "product": "福壽牌生機栽培專用肥426",
                "registeredNo": "肥製(質)字第0085078號",
                "itemName": "5-13-雜項有機質肥料",
                "organicRegisteredNo": "100001",
                "source": "福壽實業股份有限公司",
                "ingredient": ["蓖蔴粕","菜籽粕","椰子粕","芝麻粕","草木灰"],
                "methodAndDosage": "整地開植溝時，條施或撒施並均勻拌入土中。用量180公斤"
            },
            {
                "registrationType": "registered",
                "product": "東農牌1號有機質肥料",
                "registeredNo": "肥製(質)字第0042029號",
                "itemName": "植物渣粕肥料(5-01)",
                "source": "保證責任嘉義縣東石合作農場",
                "organicRegisteredNo": "100006",
                "ingredient": ["花生粕","米糠","芝麻粕","椰子粕","蓖麻粕","黃豆粕"],
                "methodAndDosage": "第一次碎土整地前，採全面撒施並均勻拌入土中。用量60公斤"
            },
            {
                "registrationType": "registered",
                "product": "青春牌超級肥",
                "registeredNo": "肥製(質)字第0004005號",
                "itemName": "混合有機質肥料(5-12)",
                "source": "力漢企業股份有限公司",
                "organicRegisteredNo": "101005",
                "ingredient": ["豆粉","菜籽粕","肉骨粉","魚粉","苜蓿"],
                "methodAndDosage": "全面撒施並均勻拌入土中。用量200公斤"
            },
            {
                "registrationType": "noRegistration",
                "product": "牛糞堆肥",
                "registeredNo": "無登記",
                "source": "朋友提供",
                "ingredient": "牛糞",
                "methodAndDosage": "用量300公斤"
            },
        ],
        "whetherPreventionMaterial": "yes",
        "preventionMaterials": [
            {
                "registrationType": "pesticide",
                "registeredNo": "農藥製字第05323號",
                "organicRegisteredNo": "101007",
                "product": "台灣水寶",
                "source": "百泰生物科技股份有限公司",
                "ingredient": "枯草桿菌"
            },
            {
                "registrationType": "pesticide",
                "registeredNo": "農藥製字第05277號",
                "organicRegisteredNo": "107042",
                "product": "興農寶",
                "source": "興農股份有限公司",
                "ingredient": "枯草桿菌"
            },
            {
                "registrationType": "planProtection",
                "registeredNo": "植保製字第00071號",
                "organicRegisteredNo": "107037",
                "product": "油夠好用",
                "source": "興農股份有限公司",
                "ingredient": "苦楝油"
            },
            {
                "product": "亞磷酸",
                "registrationType": "noRegistration",
                "source": "振勇",
            },
        ],
        "farmMaps": [
            {
                "id": "1",
                "farmer": "楊小花",
                "name": "石郎",
                "landLotSerialNo": [
                    "雙龍段0308-0000地號",
                ],
                "disabled": false,
                "uploadDate": "2021-03-12T08:20:10.000Z"
            }
        ],
        "packingLabels": [
            {
                "packingLabelFile": {
                    "type": "",
                    "size": 0,
                    "bytes": "0010",
                    "name": "包裝標示.jpg",
                    "lastModified": 0
                },
                "crop": "青江菜",
                "specs": "300g ±10%"
            }
        ],
        "property": {
            "landProperty": [
                {
                    "id": "1",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "1192-0000地號",
                    "area": "0.251",
                    "landProperty": "privateOwnedAll",
                    "registrationHectare": 20,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                },
                {
                    "id": "2",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "1208-0000地號",
                    "area": "0.251",
                    "landProperty": "privateOwnedAll",
                    "registrationHectare": 30,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                },
                {
                    "id": "3",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "0308-0000地號",
                    "area": "0.0036",
                    "landProperty": "taiSugarLand",
                    "registrationHectare": 40,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                },
                {
                    "id": "4",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "0309-0000地號",
                    "area": "0.0807",
                    "landProperty": "nationalLand",
                    "registrationHectare": 50,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                },
                {
                    "id": "5",
                    "farmer": "楊小花",
                    "city": "yilan",
                    "district": "五結鄉",
                    "landLot": "田洋段",
                    "landSerialNo": "0310-0000地號",
                    "area": "0.444",
                    "landProperty": "privateNotOwned",
                    "registrationHectare": 60,
                    "householdRegistration": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "土地登記謄本.pdf",
                        "lastModified": 0
                    }
                }
            ],
            "leaseManagement": [
                {
                    "landLotSerialNo": ["田洋段1192-0000地號", "雙龍段0310-0000地號"],
                    "leaseType": "lease",
                    "leaseExpiryDate": "2024-06-15T00:00:00.000Z",
                    "leaseFile": {
                        "type": "",
                        "size": 0,
                        "bytes": "",
                        "name": "租用檔案.pdf",
                        "lastModified": 0
                    }
                }
            ]
        },
    }
]

export default cropApplicationDrafts;